import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';

import { NotificationManager, StorageManager, useSettings } from '@atlas/core';

export const WithdrawalCashdeskPopup = ({ data, id }) => {
  const frame = useRef(null);
  const { paymentId: billingId, redirectUrl } = data;
  const { amount, currency, iframeUrl, paymentId } = qs.parse(redirectUrl);
  const { lang } = useSettings();
  const token = StorageManager.getItem('tk', '');

  const sendData = useCallback(() => {
    frame?.current?.contentWindow?.postMessage(
      {
        amount,
        billingId,
        currency,
        id,
        lang,
        paymentId,
        token,
        type: 'paymentData',
      },
      '*',
    );
  }, [currency, amount, id, token, paymentId, billingId, lang]);

  useEffect(() => {
    const messageHandler = e => {
      if (e.data.type === 'shakehand') {
        sendData();
      }

      if (e.data.type === 'closeModal') {
        NotificationManager.removeNotification(id);
      }
    };

    window.addEventListener('message', messageHandler);

    return () => window.removeEventListener('message', messageHandler);
  }, [id]);

  return (
    <iframe
      className="withdrawal-cashdesk"
      ref={frame}
      src={iframeUrl}
      title="Withdrawal Cashdesk"
    />
  );
};

WithdrawalCashdeskPopup.propTypes = {
  data: PropTypes.shape({
    paymentId: PropTypes.string,
    redirectUrl: PropTypes.string,
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
